import { SignalContext } from "context/SignalContext";
import Cookies from "js-cookie";
import { StreamingCameraType } from "lib/types";
import { useCommonService } from "pages/service";
import { useContext, useEffect, useRef, useState } from "react";
import { UsingCameraPlayer } from "ui/streaming/single-pc-adapter";
import { STREAM_TYPE_LIVE } from "webrtc-player/common/base";

export default function Panorama({ cameras, visible, onClose }) {
  const [streamingCameras, setStreamingCameras] = useState([]);
  const { getCredentials } = useCommonService();
  const token = Cookies.get("token");
  const { sessionId } = useContext(SignalContext);
  const closeStreamingRefs = useRef([]);
  const fullScreenRef = useRef(null);
  function onFullScreen() {
    const elem = fullScreenRef.current;
    // if (document.fullscreenElement) {
    //   // 如果当前处于全屏模式，则退出全屏
    //   document.exitFullscreen();
    //   return;
    // }
    if (elem) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }
    }
  }
  useEffect(() => {
    const handleFullscreenChange = () => {
      if (!document.fullscreenElement) {
        // 已退出全屏模式
        onClose?.();
      }
    };
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);
  useEffect(() => {
    if (!visible) {
      closeStreamingRefs.current.forEach((element) => {
        element?.closeStreaming();
      });
      return;
    }
    onFullScreen();
    const _streamingCameras = [];
    cameras.forEach((camera) => {
      getCredentials([camera.nvrId], camera.orgId).then(
        ([objCredentialFound]) => {
          const _streamingCamera: StreamingCameraType = Object.assign(
            {},
            camera,
            {
              orgId: camera.orgId,
              nvrId: camera.nvrId,
              devId: camera.devId,
              type: camera.type,
              cameraId: camera.id,
              cameraName: camera.name,
              token: token!,
              turn: objCredentialFound?.turn,
              rtcToken: objCredentialFound?.token,
              sessionId: sessionId,
              cameraMac: camera.macAddress,
              remoteIndex: camera.remoteIndex,
              streamId: "0",
              status: camera.status,
              siteId: camera.siteId,
              siteName: camera.siteName,
              capabilities: camera.capabilities,
              videoInfo: {
                width: camera.mainStream?.resolution.width,
                height: camera.mainStream?.resolution.height,
                fps: camera.mainStream?.frameRate,
              },
              videoInfoMainStream: {
                width: camera.mainStream?.resolution.width,
                height: camera.mainStream?.resolution.height,
                fps: camera.mainStream?.frameRate,
              },
              videoInfoSubStream: {
                width: camera.subStream?.resolution.width,
                height: camera.subStream?.resolution.height,
                fps: camera.subStream?.frameRate,
              },
            },
          );
          _streamingCameras.push(_streamingCamera);
          setStreamingCameras(_streamingCameras);
        },
      );
    });
  }, [cameras, visible]);
  return (
    <div
      style={{
        display: visible ? "grid" : "none",
        width: "100%",
        alignContent: "center",
        gridTemplateColumns: `repeat(${streamingCameras.length}, 1fr)`,
      }}
      ref={fullScreenRef}
    >
      {streamingCameras.map((camera, index) => {
        return (
          <div className="aspect-video">
            <UsingCameraPlayer
              ref={(element) => (closeStreamingRefs.current[index] = element)}
              key={index}
              muted={true}
              selected={false}
              streamingCamera={camera}
              streamType={STREAM_TYPE_LIVE}
              visible={true}
              streamId={1}
            />
          </div>
        );
      })}
    </div>
  );
}
